import { RetailMatchTimeOption } from "../../Enums/RetailMatchTimeOption";

export interface ISubmitRetailMatchJobRequest {
  title: string;
  brands: string[];
  categories: string[];
  geoType: string;
  geoValues: string[];
  timeOption: RetailMatchTimeOption;
  siteLatitude: number;
  siteLongitude: number;
  sgFilter: boolean;
  tradeAreaLimit: boolean;
  sampleSize: number;
  includeAllBuds: boolean;
  excludedLocations: string[];
}
